export default {
  GSCO: 'GSCO',
  UBSW: 'UBSW',
};
